// insert a search box that can be used anyway, pass in the onChange so you can re-use it.
// TOP LEVEL IMPORTS
import React from 'react';
// ANTD
import Input from 'antd/lib/input';

// CONSTANTS & DESTRUCTURING
// ====================================
const Search = Input.Search;

export class SearchBox extends React.Component {
  render() {
    return (
      <Search
        placeholder="search..."
        style={{ width: '100%', height: 43 }}
        onChange={e => {
          console.log(e.target.value);
          this.props.onChange(e.target.value);
        }}
        defaultValue={this.props.value}
        value={this.props.value}
      />
    );
  }
}

export default SearchBox;



// WEBPACK FOOTER //
// ./src/components/inputs/SearchBox/index.js